import { FC } from 'react';
import cx from 'classnames/bind';

import CrossIcon from '@/assets/cross.svg';

import styles from './DeleteButton.module.scss';

interface DeleteButtonProps {
  deleteMessage: () => void;
  className?: string;
}

const cn = cx.bind(styles);

const DeleteButton: FC<DeleteButtonProps> = ({ deleteMessage, className }) => (
  <button
    onClick={deleteMessage}
    className={cn('buttonCross', className)}
    type="button"
  >
    <img className={cn('iconCross')} src={CrossIcon} alt="Удалить" />
  </button>
);

export default DeleteButton;
